export default __webpack_public_path__ + "static/media/backerod_1.f398a65b.png";